module.exports = __webpack_public_path__ + "assets/assets/images/rootCanalFaq/appropriate-access-prep.4c6b0a23.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/rootCanalFaq/appropriate-access-prep.png
// module id = 298
// module chunks = 0